import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="relative mx-auto flex max-w-2xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="font-heading text-7xl font-black text-background-200 md:text-9xl">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">你访问的页面不存在或已被移除，去首页看看精彩内容吧。</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/all"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-100 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
          >
            <i className="ri-compass-3-line"></i>
            浏览全部影视
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}